<template>
  <div class="search-view-container">
    <div class="header-container">
      <LfHeaderTitleComponent :title="TEXT.title" :badgeIcon="ICON.beta" :badgeTooltip="TEXT.betaTooltip" class="header">
        <LfLabelButtonComponent
          v-if="queryDone"
          class="button"
          :text="TEXT.newQuery"
          :prependIconSrc="ICON.add"
          :action="onNewQueryClick"
          :variant="LabelButtonVariant.SOLID"
          :iconColor="'invert(1)'"
        />
      </LfHeaderTitleComponent>
    </div>

    <SearchAdvanceIAComponent :key="componentKey" />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n-composable'
import { ref, computed, onBeforeUnmount } from 'vue'
import LfHeaderTitleComponent from '@/components/HeaderTitle/LfHeaderTitleComponent.vue'
import LfLabelButtonComponent from '@/components/forms/buttons/label/LfLabelButtonComponent.vue'
import SearchAdvanceIAComponent from '@/modules/documentSearcher/components/SearchAdvanceIA/SearchAdvanceIAComponent.vue'
import { LabelButtonVariant } from '@/components/forms/buttons/types/ButtonTypes'
import { useSearchIAStore } from '@/modules/documentSearcher/stores/useSearchIAStore'
import { TrackerEvents, trackEvent } from '@/plugins/tracker'

// TRANSLATIONS
const { t } = useI18n()

const TEXT = {
  title: t('views.search_ia.title') as string,
  newQuery: t('action_buttons.new_query') as string,
  betaTooltip: 'BETA'
}

const ICON = {
  add: require('@/assets/images/svg/icon-add-circle.svg'),
  beta: require('@/assets/images/svg/icon-beta.svg')
}

// STORE
const searchIAStore = useSearchIAStore()

// REFS
const componentKey = ref(0)

// COMPUTED
const queryDone = computed(() => searchIAStore.queryDone)

// METHODS
const onNewQueryClick = () => {
  trackEvent(TrackerEvents.AI_SEARCH_NEW, { search_id: searchIAStore.search_id })
  resetState()
}

const resetState = () => {
  searchIAStore.resetSearchIAResponse()
  searchIAStore.cancelSearchIA()
  searchIAStore.resetSearchId()
  componentKey.value += 1
}

// LIFECYCLE
onBeforeUnmount(() => {
  resetState()
})
</script>

<style lang="scss" scoped>
.search-view-container {
  width: 100%;
  height: 100%;
  padding: 167px 30px 15px;

  ::v-deep .e-content {
    justify-content: center;
  }
}

.header-container {
  display: flex;
  align-items: center;
  gap: $spacing-sm;

  .header {
    flex: 1;
  }

  .button {
    white-space: nowrap;
    min-width: max-content;
  }
}

@include tabletAndMore {
  .search-view-container {
    padding-top: $app-bar-height + 15px;

    .header {
      margin-bottom: 24px;
    }
  }
}
</style>
